import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SimpleMessage from '../SimpleMessage/index'
import {Button, Message, Popover} from '@sabre/spark-react'
import config from 'config/applicationConfig'
import {cleanLocalFlightDate} from "../../utils/localFlightDate"

class LogoutPopover extends Component {

    closeMessage = () => {
        this.setState({openMessage: false})
    }

    openMessage = () => {
        this.onClose()
        this.setState({openMessage: true})
    }

    logout = () => {
        window.location.assign(config.logoutProxy + window.location.href)
        cleanLocalFlightDate()
    }

    constructor(props) {
        super(props)
        this._onKeyupBound = this.onKeyup.bind(this)
        this.state = {
            openMessage: false
        }

        this.actions = {
            onClose: this.closeMessage,
            onMessageOK: this.logout
        }
    }

    componentDidMount() {
        window.addEventListener('keyup', this._onKeyupBound)
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this._onKeyupBound)
    }

    onClose() {
        this.el.close()
        this.setState({
            openMessage: false
        })
    }

    onKeyup(e) {
        if (e.keyCode === 27) {
            this.onClose()
        }
    }

    render() {
        return (
            <React.Fragment>
                <SimpleMessage isOpen={this.state.openMessage}
                               title="Sign Out"
                               text="Do you really want to sign out?"
                               type="info"
                               actions={this.actions}/>
                <div className='spark-header__sign-in spark-popover'>
                    <Popover ref={node => this.el = node}
                             position="left"
                             anchorX="left"
                             anchorY="bottom"
                             toggleEl={
                                 <a className='spark-menu__list-link spark-popover__toggle'>{this.props.login}</a>}>
                        <div className='custom_popover_content'>
                            <Message
                                type="info"
                                inline={true}
                                title={this.props.login}
                                text="Do you want to sign out?"
                                actions={this.props.actions}/>
                            <nav className="spark-btn-group">
                                <Button className="spark-btn--sm" onClick={this.openMessage}>Sign Out</Button>
                            </nav>
                        </div>
                    </Popover>
                </div>
            </React.Fragment>
        )
    }
}

export default LogoutPopover

PropTypes.LogoutPopover = {
    actions: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/shared/components/LogoutPopover/index.js